import { render, staticRenderFns } from "./SponsoredRecommendationVideoNewPage.vue?vue&type=template&id=12c65e6f&scoped=true"
import script from "./SponsoredRecommendationVideoNewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationVideoNewPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationVideoNewPage.vue?vue&type=style&index=0&id=12c65e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c65e6f",
  null
  
)

export default component.exports